export default "__VITE_ASSET__7a784240__"